import React from 'react'
import Header from '../Layout/Header'
import Index from './Index'
import Footer from '../Layout/Footer'

function Home() {
  return (
    <div class="as_main_wrapper"> 
    <Header/>
    <Index/>
    <Footer/>
    </div>
  )
}

export default Home